(function () {
  function initGallery(root) {
    var slides = root.querySelectorAll('[data-ym-pdp-slide]');
    var thumbs = root.querySelectorAll('[data-ym-pdp-thumb]');
    if (slides.length < 2) return;
    var current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(parseInt(thumb.getAttribute('data-ym-pdp-thumb'), 10) || 0);
      });
    });

    var prev = root.querySelector('[data-ym-pdp-prev]');
    var next = root.querySelector('[data-ym-pdp-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
  }

  function initQuantity(root) {
    var input = root.querySelector('input');
    if (!input) return;
    root.querySelectorAll('[data-ym-pdp-qty-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.getAttribute('data-ym-pdp-qty-step'), 10) || 0;
        var value = (parseInt(input.value, 10) || 1) + step;
        input.value = Math.max(1, value);
      });
    });
  }

  // お気に入りは会員機能と連携するまで、このブラウザにだけ保存する
  var FAV_KEY = 'yamayama:favorites';

  function readFavorites() {
    try {
      return JSON.parse(window.localStorage.getItem(FAV_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeFavorites(list) {
    try {
      window.localStorage.setItem(FAV_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function initFavorite(button) {
    var key = button.getAttribute('data-ym-pdp-fav');
    if (!key) return;

    function render(on) {
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.setAttribute('aria-label', on ? 'お気に入りから外す' : 'お気に入りに追加');
    }

    render(readFavorites().indexOf(key) !== -1);

    button.addEventListener('click', function () {
      var list = readFavorites();
      var index = list.indexOf(key);
      if (index === -1) {
        list.push(key);
      } else {
        list.splice(index, 1);
      }
      writeFavorites(list);
      render(index === -1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ym-pdp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-ym-pdp-qty]').forEach(initQuantity);
    document.querySelectorAll('[data-ym-pdp-fav]').forEach(initFavorite);
  });
})();
